import styled, { css } from 'styled-components';

const StyledSortSelector = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  ${(props) => (props.isOneHrFilterEnabled ? 'max-height: 30px' : '')};
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: none;
  }
  .custom-select-common {
    display: flex;
  }
  .sort-dropdown-wrapper {
    left: unset;
  }
  ${(props) => (props.totalProductsCount ? '' : 'display: none;')}
  ${({ isQuickFilters }) =>
    isQuickFilters
      ? css`
          justify-content: end;
          gap: 16px;
        `
      : ''}
`;

const SortTitle = styled.span`
  font-size: ${(props) => props.theme.fonts.fontSize.body.large.secondary}px;
  font-family: Nunito;
  font-weight: 800;
`;

const SortContent = styled.span`
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
  font-family: Nunito;
`;

export { StyledSortSelector, SortTitle, SortContent };
